export default function handleElClass(
  el = null,
  className = '',
  action = 'add',
) {
  if (el) el.classList[action](className);
}
